var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Задания учителя")]),_c('work-self',{attrs:{"id":_vm.id}}),_c('h4',[_vm._v("Общие задания")]),_c('work-global',{attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }